<template>
  <div v-if="data">
    <OrderSummary
      :orderSummary="{
        ...data.summary,
        updatedAt: data.timeline[data.timeline.length - 1]?.eventAt,
        paymentMethod: data.paymentDetails?.type ?? '',
        email: data.customerDetails.customerEmail,
        firstName: data.customerDetails.customerFirstName,
        lastName: data.customerDetails.customerLastName
      }"
      class="pb-12"
      @refresh="loadOrderData"
    />
    <OrderTimeline
      :orderTimeline="data.timeline"
      :orderStatus="data.summary.status"
      class="pb-6"
    />
    <hr class="pb-6">
    <OrderDetails
      v-bind="{...data.summary, checkoutName: data.details.checkoutName}"
      class="pb-6"
    />
    <OrderPaymentMethod
      v-if="data.paymentDetails"
      :paymentDetails="data.paymentDetails"
      class="pb-6"
    />
    <OrderInstallments
      :origin="data.summary.origin"
      :installments="data.payments.map((installment) => {
        const updated = {
          ...installment,
          currency: data?.summary.currency ?? '',
          productName: data?.details.checkoutName ?? '',
        };
        return updated
      })"
    />
  </div>
  <div v-else>
    <div class="flex items-center justify-center w-full h-full">
      <TbLoading />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, onActivated } from 'vue';
import { useRoute } from 'vue-router';
import { TbLoading } from '@/components/tasty_bistro';
import { getOrder, GetOrderResponse } from './api/get_order';
import OrderSummary from './components/order_summary.vue';
import OrderTimeline from './components/order_timeline.vue';
import OrderDetails from './components/order_details.vue';
import OrderPaymentMethod from './components/order_payment_method.vue';
import OrderInstallments from './components/order_installments.vue';

const route = useRoute();
const projectId = route.params.projectId as string;
const orderId = route.params.id as string;
const data = ref<GetOrderResponse>();

const loadOrderData = async () => {
  data.value = await getOrder({ projectId, orderId });
};

onActivated(async () => {
  await loadOrderData();
});

onBeforeMount(async () => {
  await loadOrderData();
});

</script>
